import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { ORDER_DETAIL_KEY } from "@/features/pathpick/features/order-history/features/detail/constants";
import { resolvePathPickCancelReasonKey } from "@/features/pathpick/features/order-history/features/detail/utils";
import { formatPathPickOrderDate } from "@/features/pathpick/features/order-history/utils";

interface Props {
  cancelReason: string | null | undefined;
  canceledAt: string | null | undefined;
}

// 취소 주문은 스텝퍼 대신 붉은 배너 한 장을 노출한다.
// 사유가 있으면 사유를, 없으면(에이전시 취소·자동 취소 등 서버가 사유를 비워 보내는 경우)
// "주문 취소"로 폴백해 취소 사실 자체는 어떤 경우에도 배너에서 사라지지 않게 한다.
// 취소 일자는 사유 유무와 무관하게 뒤에 덧붙인다.
function PathPickOrderDetailCancelBanner({ cancelReason, canceledAt }: Props) {
  const { t } = useI18nHelper();

  // 서버가 코드로 줄 수도, 자유 텍스트로 줄 수도 있어 매핑 실패 시 원문을 그대로 쓴다.
  const reasonKey = resolvePathPickCancelReasonKey(cancelReason);
  const reasonLabel = reasonKey ? t(reasonKey) : cancelReason;

  const headline = reasonLabel
    ? `${t(`${ORDER_DETAIL_KEY}cancel_reason_prefix`)}: ${reasonLabel}`
    : t(`${ORDER_DETAIL_KEY}status_canceled`);

  // canceledAt이 없는 과거 데이터에서는 구분자까지 함께 빠져야 한다.
  const canceledAtLabel = canceledAt
    ? t(`${ORDER_DETAIL_KEY}canceled_at`, {
        date: formatPathPickOrderDate(canceledAt),
      })
    : null;

  return (
    <Flex
      padding={"16px"}
      borderRadius={"8px"}
      border={"0.5px solid #EE7D7A"}
      background={"#FFEEEE"}
    >
      <Text textStyle={"body-sm-bold"} color={"#CC1D1D"}>
        {canceledAtLabel ? `${headline} / ${canceledAtLabel}` : headline}
      </Text>
    </Flex>
  );
}

export default PathPickOrderDetailCancelBanner;
